import React, { useEffect, useState } from "react";
import Barcodedetailtable, {
  ProductImageCell,
} from "./Barcodedetailtable";
function Barcodedetaildata() {
 
 const data = [
    {
      id: "1",
      number: "10254354545",
      itemname: "Dutch Grown",
      desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
 
    },
    {
      id: "2",
      number: "10254354545",
      itemname: "Cambo",
      desc:"Lorem ipsum dolor sit amet,  labore et dolore magna.",


    },
    {
      id: "3",
      number: "10254354545",
      itemname: "Avon Bulbs",
      desc:"Lorem ipsum dolor sit amet, consectetur amagna.",


    },
    {
      id: "4",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, dolore magna.",

    },
    {
      id: "5",
      number: "10254354545",
      itemname: "Dutch Grown",
      desc:"Lorem ipsum dolor sit amet,ncididunt ut labore et dolore magna.",

    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },

      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "itemname",
      },
      
      {
        Header: "Description",
        accessor: "desc",
      },
      {
        Header: "Image",
        accessor: "img",
        Cell: ProductImageCell,
      },
      {
        Header: "Action",
        id: "action",
        accessor: "action",
        Cell: (value) => (
          <div className="flex flex-wrap">
          <div className=" text-gray-900 font-medium ">
            {" "}

            <button className="float-right mt-3">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L14 12.7709M1 12.7709L14 1" stroke="#E40000" stroke-width="2"/>
            </svg>
              </button>
          </div>
          
        </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Barcodedetailtable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default Barcodedetaildata;
